import React from 'react';
import type { CustomerStateType } from 'src/routes/Checkout/store/domains/customer/types';

import styled, { css } from 'styled-components';
import CustomerForm from './components/CustomerForm';
import type { Citizenship } from './types';
import CustomerBlockHeader from './components/CustomerBlockHeader';

type CustomerProps = {
  saveCustomerInfo: (customerInfo: CustomerStateType) => void;
  citizenships: Citizenship[];
  touristData: CustomerStateType;
  isMobile: boolean;
  showFillerButton: boolean;
  initialValues: CustomerStateType;
  onSubmit: () => void;
  mobileSubmitBtnDisabled: boolean;
  customerInfo: CustomerStateType;
};

export const Customer = (props: CustomerProps): JSX.Element => {
  const {
    touristData,
    saveCustomerInfo,
    citizenships,
    isMobile,
    showFillerButton,
    initialValues,
    onSubmit,
    mobileSubmitBtnDisabled,
    customerInfo,
  } = props;

  return (
    <StyledContainer $isMobile={isMobile}>
      <CustomerBlockHeader />
      <CustomerForm
        showFillerButton={showFillerButton}
        isMobile={isMobile}
        citizenships={citizenships}
        saveCustomerInfo={saveCustomerInfo}
        touristData={touristData}
        initialValues={initialValues}
        onSubmit={onSubmit}
        mobileSubmitBtnDisabled={mobileSubmitBtnDisabled}
        customerInfo={customerInfo}
      />
    </StyledContainer>
  );
};

const StyledContainer = styled.div<{ $isMobile: boolean }>`
  margin-bottom: 24px;

  ${(props) =>
    props.$isMobile &&
    css`
      margin-top: 16px;
    `}
`;
